<div class="flex flex-col gap-2 p-6">
  <div class="flex flex-col items-center justify-between px-2 py-4">
    <button
      mat-dialog-close
      class="self-end"
    >
      <mat-icon
        aria-hidden="false"
        aria-label="Close icon"
      >close</mat-icon>
    </button>
    <h3 class="self-center">{{ "medicalServices.appointment." + data.serviceType | translate }}</h3>
  </div>
  <div class="flex flex-col gap-3">
    <span class="text-neutral-300">{{ visitDialogLabels.serviceNameLabel }}</span>
    <span class="flex items-center justify-between">
      <span>
        {{ data.serviceName ?? "Не вказано" }}
      </span>
    </span>
    <mat-divider></mat-divider>
    @if (data.visitDate) {
      <span class="text-neutral-300">{{ visitDialogLabels.visitDateLabel }}</span>
      <span>{{ formatDateFunction(data.visitDate, true) }}</span>
      <mat-divider></mat-divider>
    }
    @if (data.doctorSpecialty) {
      <span class="text-neutral-300">{{ visitDialogLabels.doctorSpecialtyLabel }}</span>
      <span>{{ data.doctorSpecialty }}</span>
      <mat-divider></mat-divider>
    }
    @if (data.doctorName) {
      <span class="text-neutral-300">{{ visitDialogLabels.doctorNameLabel }}</span>
      <span>{{ data.doctorName }}</span>
      <mat-divider></mat-divider>
    }
    @if (data.clinicName) {
      <span class="text-neutral-300">{{ visitDialogLabels.clinicNameLabel }}</span>
      <span>{{ data.clinicName }}</span>
      <mat-divider></mat-divider>
    }
    <span class="text-neutral-300">{{ visitDialogLabels.locationLabel }}</span>
    <span>{{ data.location }}</span>
    <mat-divider></mat-divider>
    @if (data.orderNumber) {
      <span class="text-neutral-300">{{ visitDialogLabels.orderNumberLabel }}</span>
      <span>{{ data.orderNumber }}</span>
      <mat-divider></mat-divider>
    }
    @if (data.prescriptions) {
      <span class="text-neutral-300">{{ visitDialogLabels.prescriptionsLabel }}</span>
      <ul class="flex flex-col gap-2">
        @for (item of data.prescriptions; track $index) {
          <li class="flex items-center gap-3 text-sm">
            <mat-icon class="text-info-400">medication</mat-icon>
            {{ item }}
          </li>
        }
      </ul>
      <mat-divider></mat-divider>
    }
    @if (data.expirationDate) {
      <div class="flex items-center justify-between">
        <span class="text-neutral-300">{{ visitDialogLabels.expirationDateLabel }}</span>
        <span>{{ formatDateFunction(data.expirationDate, true) }}</span>
      </div>
      <mat-divider></mat-divider>
    }
    <div class="mb-4 flex items-center justify-between">
      <span class="text-neutral-300">{{ visitDialogLabels.statusLabel }}</span>
      <shared-status
        [statusValue]="data.status"
        [statusMessage]="'statuses.appointments.' + data.status | translate"
      ></shared-status>
    </div>
    @if (!!data.guaranteeId) {
      <button
        class="btn btn-secondary flex items-center justify-center"
        (click)="navigateToGuaranteeApplication(data.userId, data.guaranteeId)"
      >
        @if (!navigationBtnLoading()) {
          {{ "Перейти до медичної послуги" }}
        } @else {
          <shared-spin-loading></shared-spin-loading>
        }
      </button>
    }
  </div>
</div>
